import { Text, VStack } from "native-base";
import { memo } from "react";

import HorizontalProductList from "@/components/organisms/HorizontalProductList";
import { useProductsByCategory } from "@/hooks/domain/productCategory";

type RelatedProductListProps = {
  categoryId: string;
  onSelectProduct: (productId: string) => void;
};

const RelatedProductList = ({ categoryId, onSelectProduct }: RelatedProductListProps) => {
  const { data: relatedProducts, isLoading } = useProductsByCategory({
    categoryId,
    limit: 10,
    options: {
      enabled: !!categoryId,
    },
  });

  if (relatedProducts?.length) {
    return (
      <VStack pt="16" pb="4">
        <Text mx="4" fontSize="lg" bold>
          Produtos relacionados
        </Text>
        <HorizontalProductList
          data={relatedProducts}
          isLoading={isLoading}
          onSelect={onSelectProduct}
        />
      </VStack>
    );
  }
  return <></>;
};

export default memo(RelatedProductList);
